import React from 'react';
import PropTypes from 'prop-types';
import { tagQueries } from '../../graphql/queries';
import BBQuery from './BBQuery.js';

// uses render props pattern - https://reactjs.org/docs/render-props.html
// in this case prop is 'children' not 'render' but its the same concept

class TagById extends React.Component {
  render () {
    const { children, id } = this.props;
    return (
      <BBQuery
        query={tagQueries.TagById(id)}
        showLoader
        fetchPolicy='no-cache'
      >
        {data => {
          return children(data.tagById);
        }}
      </BBQuery>
    );
  }
}

TagById.propTypes = {
  children: PropTypes.func.isRequired,
  id: PropTypes.number.isRequired
};

export default TagById;
